import * as React from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';
import localforage from 'localforage';
import { IWidgetGraph } from '../../OnlinePanel/OnlinePanelState';
import { URL_AD_BLUE_PERCENT, URL_GRAPHS } from '../../../router/constants';
import { adBluePercWidgetGraphAtom, isGraphOpenAtom } from '../../Graphs/GraphState';
import useAnalytics from '../../../hooks/useAnalytics';
import AdBlueOnline from '../../Graphs/AdBluePerc';

export default function AdBlueWidgetGraph(props: { vehicleId: number }): JSX.Element {
  const { trackEvent } = useAnalytics();
  const { formatMessage: f } = useIntl();
  const [adBluePercWidgetGraph, setAdBluePercWidgetGraph] = useRecoilState<IWidgetGraph | null>(
    adBluePercWidgetGraphAtom
  );
  const setIsGraphOpen = useSetRecoilState<boolean | number>(isGraphOpenAtom);

  const closeWidgetGraph = (event: React.MouseEvent<HTMLAnchorElement>) => {
    trackEvent(['AdBluePerc widget', 'click', 'Close widget graph']);
    event.preventDefault();
    setAdBluePercWidgetGraph(null);
    localforage.setItem('widgetGraph', null);
    setIsGraphOpen(false);
  };

  const openAdBluePercPage = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    trackEvent(['AdBluePerc Widget', 'click', 'Open AdBluePerc page to new window']);
    window.open(
      `${URL_GRAPHS}${URL_AD_BLUE_PERCENT}/${adBluePercWidgetGraph?.vehicleId}`,
      '_blank'
    );
  };

  const getDate = () => {
    if (adBluePercWidgetGraph && adBluePercWidgetGraph.timestamp) {
      return dayjs(adBluePercWidgetGraph.timestamp).format('DD.MM.YYYY');
    }
    return '';
  };

  React.useEffect(() => {
    trackEvent(['AdBluePerc Widget', 'show', 'Widget graph']);
    return () => {
      if (adBluePercWidgetGraph && adBluePercWidgetGraph.timestamp !== undefined) {
        setAdBluePercWidgetGraph(null);
        localforage.setItem('widgetGraph', null);
        trackEvent(['AdBluePerc Widget', 'close', 'Widget graph']);
        setIsGraphOpen(false);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ background: '#fff', borderRadius: '4px', margin: '2px', width: '756px' }}>
      <div
        style={{
          padding: '10px 14px 10px 10px',
        }}
      >
        <div className="">
          <div style={{ display: 'inline-flex' }}>
            <a
              href=""
              onClick={closeWidgetGraph}
              className="cmd-icon cmd-icon-arrow-left-ext"
              title={f({ id: 'graph.onlinepanel.back' })}
              style={{
                color: '#494949',
                marginRight: '12px',
                top: '2px',
                position: 'relative',
              }}
            />
            {`${f({ id: 'widget.adblueLevel.valueName.long' })} (%)`}: {getDate()}
          </div>
          <div
            style={{
              float: 'right',
              padding: '2px 10px',
              textAlign: 'center',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
            className="e-button--gray mb-2"
            onClick={openAdBluePercPage}
          >
            {f({ id: 'table.detailBtn' })}
          </div>
        </div>
      </div>
      <div style={{ padding: '0 0 0 10px' }}>
        <React.Suspense fallback={<div>Loading...</div>}>
          <AdBlueOnline vehicleId={props.vehicleId} />
        </React.Suspense>
      </div>
    </div>
  );
}
